import { Flex, Text } from "shared/components/Spor";
import { eventIsInfrastructureEvent } from "features/History/utils/utils";
import { FC } from "react";
import {
  CombinedHistoryResponse,
  InfrastructureOperationalInformationOverviewResponse,
} from "shared/types/operationalInformation";
import { Semantics } from "shared/utils/semantics";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { ChapterFill18Icon } from "@vygruppen/spor-icon-react";
import { useLabelForActionCard } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/useLabelForActionCard";

type ActionCardLabelProps = {
  information: CombinedHistoryResponse;
  semantics: Semantics;
};

export const ActionCardLabel: FC<ActionCardLabelProps> = ({
  information,
  semantics,
}) => {
  const theme = useThemeSemantic(semantics);

  const { actionCardLabel } = useLabelForActionCard(
    (information as InfrastructureOperationalInformationOverviewResponse)
      .actionCard,
  );

  if (eventIsInfrastructureEvent(information) && information.actionCard) {
    return (
      <Flex
        alignItems="center"
        gap={1}
        color={theme.colorSemanticTextSecondary}
      >
        <ChapterFill18Icon />
        <Text variant="sm" fontWeight="bold">
          Aksjonskort {actionCardLabel ?? information.actionCard.type}
        </Text>
      </Flex>
    );
  }

  return null;
};
